<template>
  <vx-card class="grid-view-item">
    <div slot="no-body">
      <img
        :src="
          item.file !== null
            ? item.file.includes('http')
              ? item.file
              : `${this.url.baseFl}/${item.file}`
            : emptyImage
        "
        alt="content-img"
        class="responsive card-img-top"
      />
      <vs-button
        v-if="accessDelete"
        radius
        color="danger"
        class="absolute right-0 top-0 m-3"
        type="filled"
        icon="delete"
        @click="onDelete"
      ></vs-button>
    </div>
    <div class="flex justify-start mb-2">
      <vs-chip :color="item.status === 1 ? 'primary' : 'danger'">{{
        item.status === 1 ? "Aktif" : "Tidak Aktif"
      }}</vs-chip>
    </div>
    <span class="mb-2 cursor-pointer text-xl text-primary" @click="$emit('edit')">{{
      item.name
    }}</span>
  </vx-card>
</template>

<script>
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  props: {
    accessDelete: { type: Boolean, default: true },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      url,
      emptyImage,
    };
  },
  methods: {
    onDelete() {
      this.$emit("onDelete");
    },
  },
};
</script>

<style lang="scss" scoped>
.text-grey-1 {
  color: rgb(68, 68, 68);
}

.grid-view-item {
  .grid-view-img {
    max-width: 100%;
    max-height: 60%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
